const findOptional = (root, nodeName) => {
    for (let i = 0; i < root.childNodes.length; i++) {
        const childNode = root.childNodes[i];
        if (childNode?.nodeName === nodeName) {
            return childNode;
        }
    }
    return null;
};
const findRequired = (root, nodeName) => {
    for (let i = 0; i < root.childNodes.length; i++) {
        const childNode = root.childNodes[i];
        if (childNode?.nodeName === nodeName) {
            return childNode;
        }
    }
    throw new Error(`VAST XML parsing error: node with name: "${nodeName}" not found`);
};
export const parseVAST = (vastXml) => {
    try {
        const parser = new DOMParser();
        const vastDocument = parser.parseFromString(vastXml, 'application/xml');
        const parserError = findOptional(vastDocument, 'parsererror');
        if (parserError) {
            throw new Error(`VAST XML parsing error: ${parserError.textContent}`);
        }
        const vast = findRequired(vastDocument, 'VAST');
        const ad = findRequired(vast, 'Ad');
        const inLine = findRequired(ad, 'InLine');
        const creatives = findRequired(inLine, 'Creatives');
        const creative = findRequired(creatives, 'Creative');
        const nonLinearAds = findRequired(creative, 'NonLinearAds');
        const nonLinear = findRequired(nonLinearAds, 'NonLinear');
        const staticResource = findRequired(nonLinear, 'StaticResource');
        const widthAttr = nonLinear.getAttribute('width');
        const heightAttr = nonLinear.getAttribute('height');
        if (!widthAttr || !heightAttr) {
            throw new Error('NonLinear element must have width and height attributes');
        }
        const imageWidth = parseInt(widthAttr, 10);
        const imageHeight = parseInt(heightAttr, 10);
        const imageUrl = staticResource.textContent?.trim();
        if (!imageUrl || imageUrl.length === 0) {
            throw new Error('StaticResource element must contain a valid URL');
        }
        const nodeTrackingEvents = findOptional(nonLinearAds, 'TrackingEvents');
        const trackingEvents = [];
        if (nodeTrackingEvents) {
            for (let i = 0; i < nodeTrackingEvents.childNodes.length; i++) {
                const nodeTracking = nodeTrackingEvents.childNodes[i];
                if (nodeTracking && nodeTracking.nodeName === 'Tracking') {
                    const type = nodeTracking.getAttribute('event');
                    const url = nodeTracking.textContent?.trim();
                    if (type?.length && url?.length) {
                        trackingEvents.push({
                            url,
                            type,
                        });
                    }
                }
            }
        }
        const result = {
            url: imageUrl,
            height: imageHeight,
            width: imageWidth,
        };
        if (trackingEvents.length > 0) {
            result.trackingEvents = trackingEvents;
        }
        return result;
    }
    catch (error) {
        if (error instanceof Error) {
            throw new Error(`Error parsing VAST XML: ${error.message}`);
        }
        else {
            throw new Error('Unknown error occurred while parsing VAST XML');
        }
    }
};
export const loadAndParsePauseVAST = async (vastUrl, signal) => {
    try {
        const response = await fetch(vastUrl, {
            method: 'GET',
            signal,
            headers: {
                Accept: 'application/xml, text/xml, */*',
            },
        });
        if (!response.ok) {
            throw new Error(`Failed to fetch VAST XML: HTTP ${response.status} ${response.statusText}`);
        }
        const vastXml = await response.text();
        return parseVAST(vastXml);
    }
    catch (error) {
        if (error instanceof Error && error.name === 'AbortError') {
            throw new Error('VAST XML request was aborted');
        }
        else if (error instanceof Error) {
            throw new Error(`Error loading VAST XML: ${error.message}`);
        }
        else {
            throw new Error('Unknown error occurred while loading VAST XML');
        }
    }
};
